export const fromTimestampToDate = (
  value: string,
  viewHours: boolean = false
) => {
  const datetime = new Date(
    Number(parseFloat(value).toString().padEnd(13, '0'))
  )
    .toISOString()
    .split('T');
  return `${datetime[0]}${viewHours ? ' ' + datetime[1].substring(0, 8) : ''}`;
};
